// 2. TourSlider.jsx (Replace your current TourSlider.jsx)
import React from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Grid, Box, Typography, Button, CircularProgress } from "@mui/material";
import { useDestinations } from "./destinations"; // Updated import

const DestinationCard = ({ destination }) => {
  const navigate = useNavigate();

 // Updated handleBookNow - TEENO prices URL mein jayenge
const handleBookNow = () => {
  const tripName = destination.title.replace(/ /g, "-").toLowerCase();
  const p1 = destination.price_per_person || "0.00";
  const p2 = destination.price_for_two || "0.00";
  const p3 = destination.price_for_three_or_more || "0.00";
  
  navigate(`/sight-tour-booking?trip=${tripName}&p1=${p1}&p2=${p2}&p3=${p3}`, {
    state: {
      tourId: destination.id,
      tourName: destination.title,
      price_per_person: p1,
      price_for_two: p2,
      price_for_three_or_more: p3
    },
  });
};


  return (
    <Box
      className="destination-card"
      sx={{
        position: "relative",
        borderRadius: "20px",
        overflow: "hidden",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
        height: "100%",
        flex: 1,
      }}
    >
      <Box className="slider-container" sx={{ height: "40vh", width: "100%" }}>
        <Swiper
          modules={[Pagination, Autoplay]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          pagination={{
            clickable: true,
            type: "bullets",
          }}
          style={{
            height: "100%",
            width: "100%",
            "--swiper-pagination-color": "#9B1321",
          }}
        >
          {destination.images.map((img, imgIndex) => (
            <SwiperSlide key={imgIndex}>
              <img
                src={img}
                alt={destination.title}
                width="100%"
                height="100%"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "20px 20px 0 0",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      <Box
        sx={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "#333",
            fontSize: { xs: "1.2rem", sm: "1.5rem" },
          }}
        >
          {destination.title}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "#666",
            fontSize: { xs: "0.9rem", sm: "1rem" },
            marginBottom: "15px",
          }}
        >
          {destination.description}
        </Typography>

        <Button
          variant="contained"
          onClick={handleBookNow}
          sx={{
            width: "80%",
            maxWidth: "200px",
            padding: "10px 20px",
            borderRadius: "25px",
            backgroundColor: "#9B1321",
            color: "#fff",
            textTransform: "none",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4)",
            "&:hover": {
              backgroundColor: "red",
            },
          }}
        >
          Book Now
        </Button>
      </Box>
    </Box>
  );
};

const TourSlider = () => {
  const { destinations, loading } = useDestinations();

  if (loading) {
    return (
      <section className="pricing-section-two alternate" style={{ marginTop: "10vh" }}>
        <div className="sec-title text-center">
          <h2 style={{ display: "inline-block", borderBottom: "2px solid #9B1321", paddingBottom: "10px" }}>
            Tourist Attractions in Jordan
          </h2>
        </div>
        <Box sx={{ padding: "30px", textAlign: "center" }}>
          <CircularProgress />
        </Box>
      </section>
    );
  }

  return (
    <section className="" style={{ marginTop: "10vh" }}>
      <div className="sec-title text-center">
        <h2
          style={{
            display: "inline-block",
            borderBottom: "2px solid #9B1321",
            paddingBottom: "10px",
          }}
        >
          Tourist Attractions in Jordan
        </h2>
      </div>

      <Box sx={{ padding: "30px", textAlign: "center" }}>
        <Grid container spacing={4} justifyContent="center">
          {destinations.map((destination, index) => (
            <Grid item xs={12} sm={6} md={6} lg={4} key={destination.id || index}>
              <DestinationCard destination={destination} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </section>
  );
};

export default TourSlider;